const yup = require('yup')

const shape = {
  serial: yup.string().default(''),
}

const signDeviceSchema = yup.object().shape(shape)

module.exports = { signDeviceSchema }
